// src/services/api/managedserviceService.ts
import { api } from "./api";
import { IManagedService } from "../../types/managedservice";
import { config } from "../../config/environment";

//const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const CLINIC_ID = config.clinic.id;

// Types for request payloads
//export interface CreateTestimonialPayload
//  extends Omit<ITestimonial, "clinicId" | "testimonialId" | "_id"> {
//  slug?: string;
//}

//export type UpdateTestimonialPayload = Partial<CreateTestimonialPayload>;

export const managedserviceService = {
  getAllManagedServices: async () => {
    const response = await api.get<IManagedService[]>(
      `/clinics/${CLINIC_ID}/managedservices`
    );
    return response.data;
  },

  getManagedServiceById: async (managedserviceId: string) => {
    const response = await api.get<IManagedService>(
      `/clinics/${CLINIC_ID}/managedservices/${managedserviceId}`
    );
    return response.data;
  },

  createManagedService: async (managedservice: IManagedService) => {
    const response = await api.post<IManagedService>(
      `/clinics/${CLINIC_ID}/managedservices`,
      managedservice
    );
    return response.data;
  },

  updateManagedService: async (
    managedserviceId: string,
    managedservice: IManagedService
  ) => {
    const response = await api.put<IManagedService>(
      `/clinics/${CLINIC_ID}/managedservices/${managedserviceId}`,
      managedservice
    );
    return response.data;
  },

  deleteManagedService: async (managedserviceId: string) => {
    await api.delete(
      `/clinics/${CLINIC_ID}/managedservices/${managedserviceId}`
    );
  },
};
